// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Vl-z","tupacHeader":"Wl-z","tupacHeader2":"Xl-z","tupacMenu":"Yl-z","tupacMenu2":"Zl-z","tupacMain":"_l-z","tupacMain2":"am-z"};